import React from 'react'
import './theme.scss'

export default function FormWrapper({ children }) {
    return <div className="form-wrapper">{children}</div>
}
